export default "__VITE_ASSET__DkrSNz_M__"